/**
 * @generated SignedSource<<5c13f9b28d5f8501e3f45ed9173dc793>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HeartbeatReportLockInput = {
  reportId?: string | null;
  token?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type HeartbeatReportLockMutation$variables = {
  input: HeartbeatReportLockInput;
};
export type HeartbeatReportLockMutation$data = {
  readonly heartbeatReportLock: {
    readonly token: string | null;
    readonly locked: boolean | null;
    readonly heldByViewer: boolean | null;
    readonly holder: {
      readonly id: string;
      readonly fullName: string | null;
      readonly profilePictureId: string | null;
    } | null;
    readonly lockedAt: string | null;
    readonly expiresAt: string | null;
  } | null;
};
export type HeartbeatReportLockMutation = {
  variables: HeartbeatReportLockMutation$variables;
  response: HeartbeatReportLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HeartbeatReportLockPayload",
    "kind": "LinkedField",
    "name": "heartbeatReportLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heldByViewer",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "holder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profilePictureId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lockedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HeartbeatReportLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HeartbeatReportLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "30d0327dd919d7e8864c34cb6badffae",
    "id": null,
    "metadata": {},
    "name": "HeartbeatReportLockMutation",
    "operationKind": "mutation",
    "text": "mutation HeartbeatReportLockMutation(\n  $input: HeartbeatReportLockInput!\n) {\n  heartbeatReportLock(input: $input) {\n    token\n    locked\n    heldByViewer\n    holder {\n      id\n      fullName\n      profilePictureId\n    }\n    lockedAt\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "24eb36c5919933fa2c45b792afe20002";

export default node;
